import Styled from 'styled-components'

export const LabelAlignStart = Styled.label`
    align-self: flex-start;
    font-weight: bold;
    padding-bottom: .4rem;
    text-align: initial;
`
